import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "~common/service/authentication.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { AuthenticationResult } from "@azure/msal-browser";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  isProcess = false;
  validateForm: FormGroup;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private message: NzMessageService,
    private msalService: MsalService
  ) {}

  async submitAzureForm() {
    localStorage.clear();

    this.msalService
      .loginPopup()
      .subscribe((response: AuthenticationResult) => {
        this.msalService.instance.setActiveAccount(response.account);
        this.isProcess = true;

        const loginReq = {
          // email: response.account.username
          email: response.accessToken,
        };

        this.authService
          .login(loginReq)
          .then((result) => {
            if (result && result.isSuccess) {
              this.authService.saveMicrosoftToken(response.accessToken);
              this.authService.saveToken(result.payload.token);
              this.authService.me().then((result) => {
                this.authService.saveProfile(result.payload);
                if (result.payload.isAdmin) {
                  this.router.navigate([
                    this.authService.getRedirectUrl()
                      ? this.authService.getRedirectUrl()
                      : "/admin",
                  ]);
                } else {
                  this.router.navigate([
                    this.authService.getRedirectUrl()
                      ? this.authService.getRedirectUrl()
                      : "/",
                  ]);
                }
                this.isProcess = false;
              });
            } else {
              this.isProcess = false;
              this.message.create("error", result.message);
            }
          })
          .catch((err) => {
            this.isProcess = false;
            console.log("error:", err);
            this.message.create("error", err.message);
          });
      });
  }
}
